export enum UserDetailsScreenUIState {
  ViewDetails = 1,
  ViewRoles = 2,
  AddRoles = 3
}
